/**
 * Created by pablo on 8/22/17.
 */

var integrateTN;
var form = "integrate_tn_form";
(function ($, undefined) {
    'use strict';

    integrateTN = {};
    integrateTN.form = $("#"+form);
    integrateTN.redirect = function(e){
                                    e.preventDefault();
                                    if($("#tn_shop_name").val() !== ""){                                      
                                        window.location = "https://"+$("#tn_shop_name").val()+".mitiendanube.com/admin/apps/588/authorize/";
                                    }
                                    else{
                                        alert("Por favor ingresa el nombre de tu tienda");
                                    }
                            };

    //binding
    integrateTN.form.on('submit', integrateTN.redirect);

})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/tiendaNube.integrate.js